import * as React from "react";
import Breadcrumbs from "../core/Breadcrumbs";
import { Link } from "react-router-dom";
import usePromise from "../hooks/usePromise";
import { getEmployeeCommissions } from "../../libs/commission_calculator";
import ModernCard from "../core/ModernCard";
import EmployeeCommissionsTable from "./EmployeeCommissionsTable";
import CommissionDashboardEmployee from "./dashboard/CommissionDashboardEmployee";

function CommissionEmployeeIndex({ user, org }) {
  const [commissions, { loading: loadingCommissions }] = usePromise(() =>
    getEmployeeCommissions(user.id)
  );

  return (
    <>
      <Breadcrumbs crumbs={[{ label: "Commission Calculator" }]} />
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <Link to={"/tester"} className={"btn btn-default"}>
              <i className="fa fa-calculator" /> Tester
            </Link>
          </div>
          {user.isAdmin && (
            <div className="level-item">
              <Link to={"/admin"} className={"btn btn-default"}>
                <i className="fa fa-user-secret" /> Admin
              </Link>
            </div>
          )}
        </div>
      </div>
      <CommissionDashboardEmployee
        user={user}
        commissions={commissions}
        loadingCommissions={loadingCommissions}
      />
      <ModernCard title={"Your Commissions"} ta="left" m="0pxß">
        <EmployeeCommissionsTable user={user} commissions={commissions} />
      </ModernCard>
    </>
  );
}

export default CommissionEmployeeIndex;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionEmployeeIndex.tsx